import { immerable } from "immer";
import { filtersTypeEnum } from "@sttedra_ui/framework";

import { tableViews, useSmallAddLabel } from "@/composables/_commons/helper.js";
import { appUserGroupList } from "@/api/users-groups/users-groups.api.js";

export default class UsersGroupsTableConfig {
  [immerable] = true;

  constructor(
    fromUserHasGroups,
    buildModal,
    buildUserGroupHasUsersModal,
    deleteRegister
  ) {
    const fields = [
      {
        field: "nombre",
        label: "Nombre",
      },
      {
        field: "tipoGrupo",
        label: "Tipo",
      },
      {
        field: "numeroUsuarios",
        label: "Nº Usuarios",
        sortable: false,
      },
      {
        field: "numeroInformes",
        label: "Nº Informes",
        sortable: false,
      },
    ];

    const advancedFilters = [
      {
        field: "nombre",
        label: "Nombre",
      },
    ];

    let headerItems = [
      {
        label: useSmallAddLabel() ? "Añadir" : "Añadir grupo",
        icon: "add",
        command: () => buildModal(),
        extended: true,
      },
    ];

    let actionItems = [
      {
        label: "Usuarios del grupo",
        icon: "group",
        command: (event) => buildUserGroupHasUsersModal(event),
        extended: false,
      },
      {
        label: "Editar",
        icon: "edit",
        command: (event) => buildModal(event),
        extended: false,
        hidden: (data) => data.tipoGrupo !== "Local",
      },
      {
        label: "Borrar",
        icon: "delete",
        command: (event) => deleteRegister(event),
        extended: false,
        classObj: ["delete-action"],
        // disabled: (data) => data.numeroUsuarios > 0,
      },
    ];

    let filterItems = [
      {
        type: filtersTypeEnum.GLOBAL,
        fields: advancedFilters,
      },
      {
        type: filtersTypeEnum.ADVANCED,
        fields: advancedFilters,
      },
    ];

    if (fromUserHasGroups) {
      headerItems = [];
      actionItems = [];
      filterItems = [];
    }

    return {
      title: fromUserHasGroups ? null : "Grupos de usuarios",
      api: (params) => appUserGroupList(params, fromUserHasGroups),
      schema: fields,
      actions: {
        header: headerItems,
        item: actionItems,
      },
      filters: filterItems,
      views: tableViews(),
    };
  }
}
